import {createClient} from '@vercel/edge-config'
import {defaultLocaleId} from '@local/config/locales.mjs'

// current server locale
export const locale: {current: string} = {current: defaultLocaleId}
export const setLocale = (value) => { locale.current = value || defaultLocaleId }

type Rule = {
	source: string
	destination: string
	locale: boolean
}
export const routes: {current: {rewrites: Rule[], redirects: Rule[]}} = {current: {rewrites: [], redirects: []}}
export const fetchRoutes = async () => {
	if (process.env.EDGE_CONFIG) {
		const config = createClient(process.env.EDGE_CONFIG)

		const _routes = await config?.getAll().catch(e => {
			console.warn(e)
		})
		if (!_routes?.rewrites) {
			console.warn(`Vercel Edge Config 'rewrites' not found`)
		}
		routes.current = {rewrites: _routes?.rewrites as Rule[] || [], redirects: _routes?.redirects as Rule[] || []}
	}

	return routes.current
}
